import MailTo, { MailToProps } from './MailTo';

export default MailTo;
export type { MailToProps };
